import React, {createContext} from 'react'
import {NinchatAttributes} from 'api/types'


// eslint-disable-next-line no-extra-parens
export const AppContext = createContext<AppState | undefined>(undefined)

const {Provider} = AppContext

export interface AppStateValue {
    lightBox: {
        open: boolean
        imageSrc: string | null
        imageAttr: NinchatAttributes.NinchatFileAttributes | null
        options: {
            downloadDisabled?: boolean
        }
    }
}

export interface AppState {
    appState: AppStateValue
    setAppState: React.Dispatch<React.SetStateAction<AppStateValue>>
}

export const AppProvider = ({children}: {children: React.ReactNode}) => {
    const [appState, setAppState] = React.useState<AppStateValue>({
        lightBox: {
            imageAttr: null,
            imageSrc: null,
            open: false,
            options: {downloadDisabled: false},
        },
    })

    return (
        <Provider value={{
            appState,
            setAppState,
        }}
        >
            {children}
        </Provider>
    )
}
